import { PropsWithChildren } from 'react'

import './question-list.scss'

export function QuestionList({ children }: PropsWithChildren) {
  return <div className="QuestionList">{children}</div>
}
